import { useEffect, useState } from "react";
import authSvc from "../../services/api/auth";
import { MediaUrl } from "../../utils/configuration";
import FormInput from "../../components/form-input/FormInput";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { register2FASchema } from "../../models/schema/auth";
import { LoaderCircle } from "lucide-react";
import { notify } from "../../common/notificationService";
import { useNavigate } from "react-router-dom";
import { UrlCollection } from "../../common/url-collection";

const Register2FA = () => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState<boolean>(false);
    const [qr2FA, setQr2FA] = useState<{ secretKey: string, filePath: string }>({ secretKey: '', filePath: '' })
    const { register, formState: { errors, isDirty }, handleSubmit } = useForm({
        resolver: yupResolver(register2FASchema),
        defaultValues: {
            verifyCode: ''
        }
    })

    const hanldeGetQR2FA = async () => {
        try {
            const res = await authSvc.getQR2FA();
            if (res && res.content) {
                setQr2FA(res.content)
            }
        } catch (error) {
            console.log(error);

        }
    }

    const onSubmit = async (data: { verifyCode: string }) => {
        try {
            setLoading(true);
            const res = await authSvc.enable2FA({
                verifyCode: data.verifyCode,
                secretKey: qr2FA.secretKey,
            });

            if (res && res.content.status) {
                notify("Thành công", "Bật xác thực hai yếu tố thành công", "success");
                navigate(UrlCollection.UserInfo)
            } else {
                notify("Lỗi", res.content.error || "Bật xác thực hai yếu tố thất bại", "danger");
            }

        } catch (error) {
            console.log(error);

        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        hanldeGetQR2FA();
    }, [])

    return (
        <div className="page-wrapper h-full">
            <div className="mx-auto p-4 bg-white rounded-lg shadow">
                <div className="flex justify-center items-center gap-5">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="flex-1 flex flex-col gap-1 text-base justify-start">
                            <span>Để sử dụng ứng dụng xác thực hai yếu tố, hãy thực hiện theo các bước sau:</span>
                            <span>1. Tải xuống ứng dụng xác thực hai yếu tố như Microsoft Authenticator hoặc Google Authenticator</span>
                            <span>2. Quét mã QR hoặc nhập khóa này: <span className="font-medium">{qr2FA.secretKey}</span> vào ứng dụng xác thực hai yếu tố của bạn. Lưu ý khoảng trắng và chữ hoa chữ thường không quan trọng.</span>
                            <FormInput
                                className="mt-4"
                                label="Mã xác nhận"
                                name="verifyCode"
                                type="text"
                                register={register("verifyCode")}
                                error={errors.verifyCode}
                            />
                            <div className="">
                                <button
                                    type="submit"
                                    className="mt-4 px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 min-w-[80px] disabled:opacity-50 disabled:cursor-not-allowed"
                                    disabled={!isDirty}
                                >
                                    {loading ? <LoaderCircle /> : "Xác nhận"}
                                </button>
                            </div>
                        </div>
                    </form>
                    <div className="min-w-[260px] py-5 max-w-[366px] flex flex-col justify-center items-center border border-solid border-[#D9D9D9] rounded">
                        <span>Mã QR</span>
                        <img src={MediaUrl + qr2FA.filePath} alt="qr-code" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Register2FA